module.exports = __webpack_public_path__ + "img/raining.f07c0bcb.svg";